module.exports = __webpack_public_path__ + "static/media/profile-picture-901w.4794db89.jpg";